import upp from './app.module';

upp.directive('app', function() {
    return {
        restrict: 'E',
        templateUrl: require('./app.component.html'),
        controller: 'upp.MainCtrl',
    };
});



// WEBPACK FOOTER //
// ./src/app/app.component.js